import { useRef, useEffect } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { AvatarPlayer } from "./avatar-player";

interface OtherPlayerProps {
    position: { x: number; y: number; z: number };
    rotation: number;
    colors?:any;
    isMoving?:boolean
}

export const OtherPlayer = ({ position, rotation,colors,isMoving }: OtherPlayerProps) => {
    const meshRef = useRef<THREE.Mesh>(null);

    const targetPosition = useRef(new THREE.Vector3(position?.x||0, position?.y||0, position?.z||0));
    const targetRotation = useRef(rotation);

    useEffect(() => {
        targetPosition.current.set(position?.x||0, position?.y||0, position?.z||0);
        targetRotation.current = rotation;
    }, [position, rotation]);

    useFrame((_, delta) => {
        if (meshRef.current) {
            const lerpFactor = 10 * delta; 

            meshRef.current.position.lerp(targetPosition.current, lerpFactor);

            meshRef.current.rotation.y = THREE.MathUtils.lerp(
                meshRef.current.rotation.y,
                targetRotation.current,
                lerpFactor
            );
        }
    });

    return (
        <mesh ref={meshRef} position={[position?.x||0, position?.y||0, position?.z||0]}>
            <AvatarPlayer isMoving={isMoving} colors={colors} />
        </mesh>
    );
};